<div class="gt-routes-list-containerss gt-grid-left-top-corner-flat">
    <div class="gt-list-outer-containers">
        <dx-data-grid #companyGrid *ngIf="contactTags != null && companies != null" id="gridContainer"
            [dataSource]="companies" class="gt-data-grid-style gt-grid-left-top-corner-round contacts-companies-list"
            [remoteOperations]="false" [allowColumnReordering]="true" [rowAlternationEnabled]="true"
            [showBorders]="true" (onRowClick)="showDetails($event)" height="100%"
            (onCellPrepared)="onCellPrepared($event)" [allowColumnResizing]="true" [columnResizingMode]="'widget'"
            [columnAutoWidth]="false" [showBorders]="true" [scrolling]="{ mode: 'standard', useNative: true }"
            [width]="'100%'" [hoverStateEnabled]="true"> 
            <dxo-scrolling mode="standard"></dxo-scrolling>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-paging [enabled]="false"></dxo-paging>

            <dxo-toolbar>
                <dxi-item width="50%" location="before">
                    <dx-text-box
                        [(value)]="searchTerm"
                        mode="search"
                        valueChangeEvent="keyup"
                        width="100%"
                        class="custom-search-panel"
                        (onValueChanged)="companyGrid.instance.searchByText($event.value)"
                        i18n-placeholder="@@companiesSearch"
                        placeholder="Search companies..."
                    ></dx-text-box>
                </dxi-item>
                <dxi-item width="50%">
                    <div class="gt-flex-dir-row">
                        <app-gpd-button i18n-text="@@newContact"
                            text="New Contact" icon="add" (onClick)="goToAddCompany()"></app-gpd-button>
                    </div>
                </dxi-item>
            </dxo-toolbar>

            <dxi-column dataField="name" i18n-caption="@@name" caption="Name"></dxi-column>
            <dxi-column dataField="phone" i18n-caption="@@phone" caption="Phone" dataType="text"></dxi-column>

            <dxi-column dataField="fullAddress" i18n-caption=@@address caption="Address" cellTemplate="adresseTemplate"
                alignment="left">
                <div *dxTemplate="let item of 'adresseTemplate'">
                    <div *ngIf="item.data.address != null && item.data.zipcode != null && item.data.city != null; else addressNotComplete"
                        [innerHtml]="highlightText(item.data.address + ', ' + item.data.zipcode + ' ' + item.data.city)">
                    </div>
                    <ng-template #addressNotComplete>

                    </ng-template>
                </div>
            </dxi-column>

            <dxi-column dataField="tags" i18n-caption="@@tags" caption="Tags" alignment="left"
                cellTemplate="tagTemplate" [calculateFilterExpression]="calculateFilterExpression"
                [allowFiltering]="true" [allowHeaderFiltering]="true">
                <dxo-header-filter [dataSource]="tagFilterDataSource"></dxo-header-filter>
                <div *dxTemplate="let item of 'tagTemplate'" width="20%">
                    <div class="contact-tag-container">
                        <gpd-pill
                            *ngFor="let tag of item.data.tags"
                            [text]="getTag(tag)"
                            backgroundColor="var(--color-secondary)"
                            color="var(--color-primary)"
                        ></gpd-pill>
                    </div>
                </div>
            </dxi-column>
        </dx-data-grid>
    </div>
</div>